import { BaseApiService } from "../services/baseApiService";
import ShowNotifications from "../utils/notification";

class ApiProvider extends BaseApiService {
    constructor() {
        super();
    }

    async getUserList(input) {
        try {
            const response = await this.get(`/users`, input);
            if (response.success) {
                return { status: true, response: response.data };
            } else {
                return { status: false, response: response.error?.response?.data || null };
            }
        } catch (error) {
            console.error("Error fetching users:", error);
            return { status: false, response: null };
        }
    }

    async serchLimanCrmUsers(input) {
        try {
            const response = await this.get(`/linemanCrmUsers`, input);
            if (response.success) {
                return { status: true, response: response.data };
            } else {
                return { status: false, response: response.error?.response?.data || null };
            }
        } catch (error) {
            console.error("Error fetching users:", error);
            return { status: false, response: null };
        }
    }

    async createUser(input) {
        try {
            const response = await this.post("/users", input, "User created successfully");
            if (response.status === 200 || response.status === 201) {
                return { status: true, response: response.data };
            } else {
                return { status: false };
            }
        } catch (error) {
            console.error("Create user error:", error);
            return { response: null, status: false };
        }
    }

    async updateUser(id, input) {
        try {
            const response = await this.put(`/users/${id}`, input, "User updated successfully");
            if (response.status === 200 || response.status === 201) {
                return { status: true, response: response.data };
            } else {
                return { status: false };
            }
        } catch (error) {
            console.error("Update user error:", error);
            return { response: null, status: false };
        }
    }

    async deleteUser(id, updatedUser) {
        try {
            // Using PUT as soft-delete as per existing logic, but through BaseApiService
            const response = await this.put(`/users/${id}`, updatedUser, "User deleted successfully");
            if (response.status === 200 || response.status === 201) {
                return { status: true, response: response.data };
            } else {
                return { status: false, response: response.data };
            }
        } catch (error) {
            console.error("Delete failed:", error);
            return null;
        }
    }

    async Userbyid(id) {
        try {
            const response = await this.get(`/admin-user/${id}`);
            if (response.status === 200 || response.status === 201) {
                return { status: true, response: response.data };
            } else {
                return { status: false, response: response.error?.response?.data || null };
            }
        } catch (error) {
            console.error("Error fetching user detail:", error);
            return { status: false, response: null };
        }
    }

    async getUserById(id) {
        try {
            const response = await this.get(`/users/${id}`);
            if (response.status === 200 || response.status === 201) {
                return { status: true, response: response.data };
            } else {
                return { status: false, response: response.error?.response?.data || null };
            }
        } catch (error) {
            console.error("Error fetching user detail:", error);
            return { status: false, response: null };
        }
    }

    async getCashSettlement(input) {
        try {
            const response = await this.get(`/cashsettlement-list`, input);
            if (response.status === 200 || response.status === 201) {
                return { status: true, response: response.data };
            } else {
                return { status: false, response: response.error?.response?.data || null };
            }
        } catch (error) {
            console.error("Error fetching cash settlement:", error);
            return { status: false, response: null };
        }
    }

    async updateCashSettlement(input) {
        try {
            const response = await this.patch(`/cashsettlement-status/${input.id}`, { status: input.status }, "Status updated successfully");
            if (response.status === 200 || response.status === 201) {
                return { status: true, response: response.data };
            } else {
                return { status: false, response: response.data };
            }
        } catch (error) {
            console.error("Error updating cash settlement:", error);
            return { status: false, response: null };
        }
    }

    async getUserListForList(input) {
        try {
            const response = await this.get("/users/all", input);
            if (response.status === 200 || response.status === 201) {
                return { status: true, response: response.data };
            } else {
                return { status: false, response: response.error?.response?.data || null };
            }
        } catch (error) {
            console.error("Error fetching users for list:", error);
            return { status: false, response: null };
        }
    }
}

export default new ApiProvider();